import { useState, useRef, useCallback } from 'react';

import LoginPrompt from 'components/common/loginprompt/LoginPrompt';
import Modal from '@core/components/Modal/Modal';
import LinkButton from '@core/components/linkbutton/LinkButton';
import FeaturedCourseCard from './FeaturedCourseCard';

import UseToast from 'hooks/use-toast';
import UseModal from 'hooks/use-modal';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import { ArrowRight2 } from 'iconsax-react';

import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import 'swiper/components/pagination/pagination.scss';

import classes from './FeaturedCareerPath.module.scss';




const FeaturedCareerPath = ({ content }) => {
    const { toast, ToastContainer } = UseToast();
    const [activeTab, setActiveTab] = useState('1');
    const {
        show: loginNoticeVisible,
        showModal: loginNoticeShowModal,
        destroyModal: loginNoticeDestroyModal
    } = UseModal();

    const sliderRef = useRef(null);

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        sliderRef.current.swiper.slideNext();
    }, []);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <>
            <div className={`${classes['explore-feature-content-wrapper']} py-5`}>
                <div className="container d-flex flex-column gap-3">
                    <h3>Explore Courses</h3>
                    <p>Stay updated with the latest learning courses tailored to your role.</p>
                    <div className={classes['content-wrapper']}>
                        <div>
                            <h4>Explore Career Paths</h4>
                            <p>
                                Grow in your career and get new skills with these Paths
                            </p>
                            <LinkButton to={'/career-path'} kind="secondary">Explore All</LinkButton>
                        </div>
                        <div>
                            <TabContext value={activeTab}>
                                <TabList
                                    onChange={handleTabChange}
                                    variant="scrollable"
                                    TabIndicatorProps={{ sx: { display: 'none' } }}
                                >
                                    {content.map((careerPath, index) => (
                                        <Tab
                                            key={index}
                                            value={String(index + 1)}
                                            label={<div className={classes['tab-title']}>{careerPath.short_name || careerPath.name}</div>}
                                            sx={{
                                                borderBottom: 'none',
                                                padding: '0 5px',
                                                minWidth: 'auto',
                                                minHeight: 'auto',
                                                '&.Mui-selected': {
                                                    borderBottom: 'none',
                                                    boxShadow: 'none',
                                                },
                                                '&.Mui-selected div': {
                                                    borderColor: '#18BBA8 !important',
                                                },
                                            }}
                                        />
                                    ))}
                                </TabList>
                                {content.map((careerPath, index) => (
                                    <TabPanel sx={{ padding: '5px 0' }} value={String(index + 1)}>
                                        <div className='d-flex align-items-center'>
                                            <div className={classes['cards-wrapper']}>
                                                {careerPath.lectures.map((lecture, lectureIndex) => (
                                                    <FeaturedCourseCard key={lectureIndex} data={lecture} />
                                                ))}
                                            </div>
                                            <LinkButton className='d-none d-lg-block' to={`/career-path/${careerPath.id}/${careerPath.slug}`} kind="simple">
                                                <ArrowRight2 />
                                            </LinkButton>
                                        </div>
                                    </TabPanel>
                                ))}
                            </TabContext>
                        </div>
                    </div>
                </div>
            </div >
            <Modal
                type={MOBILE_FULLSCREEN}
                closeHandler={loginNoticeDestroyModal}
                show={loginNoticeVisible}>
                <div
                    className={`${classes['login-notice-modal']} d-flex flex-column justify-content-center container`}>
                    <div className={`d-flex flex-column align-items-center justify-content-center`}>
                        <LoginPrompt />
                    </div>
                </div>
            </Modal>
            <ToastContainer />
        </>
    );
};

export default FeaturedCareerPath;
